import { Tabs } from "@snapchat/web-core-ui";
import { SpotlightForLensesOption } from "../../../common/Shell/webConfigContext";
import getTabs from "./getTabs";
function MoreContentTabs({ tabs, idPrefix }) {
    return <Tabs idPrefix={idPrefix} tabs={tabs}/>;
}
export default function getMoreContentOptionTabs(idPrefix, size, lensName, spotlightOption, spotlightsUsingThisLens, moreLenses) {
    const [spotlightsTab, lensesTab] = getTabs(size, spotlightsUsingThisLens, lensName, moreLenses);
    switch (spotlightOption) {
        case SpotlightForLensesOption.spotlightsFirst:
            if (spotlightsUsingThisLens.length > 0 && moreLenses.length > 0) {
                return <MoreContentTabs idPrefix={idPrefix} tabs={[spotlightsTab, lensesTab]}/>;
            }
            break;
        case SpotlightForLensesOption.lensesFirst:
            if (spotlightsUsingThisLens.length > 0 && moreLenses.length > 0) {
                return <MoreContentTabs idPrefix={idPrefix} tabs={[lensesTab, spotlightsTab]}/>;
            }
            break;
        default:
        case SpotlightForLensesOption.disabled:
            // Do not render anything
            break;
    }
    return null;
}
